import { render, staticRenderFns } from "./BriefBuilder.vue?vue&type=template&id=84f2b3c4"
import script from "./BriefBuilder.vue?vue&type=script&lang=js"
export * from "./BriefBuilder.vue?vue&type=script&lang=js"
import style0 from "./BriefBuilder.vue?vue&type=style&index=0&id=84f2b3c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports